export const TEST_IDS = {
    // Header
    headerLogo: 'header-logo',
    navAbout: 'nav-link-about',
    navPlatforms: 'nav-link-platforms',
    navComingSoon: 'nav-link-coming-soon',
    headerCta: 'header-cta-explore-platforms',
    mobileMenuToggle: 'mobile-menu-toggle',
    mobileMenu: 'mobile-menu',
    mobileNavAbout: 'mobile-nav-about',
    mobileNavPlatforms: 'mobile-nav-platforms',
    mobileNavComingSoon: 'mobile-nav-coming-soon',
    mobileHeaderCta: 'mobile-header-cta',

    // Hero
    heroSection: 'hero-section',
    heroHeadline: 'hero-headline',
    heroExploreLq: 'hero-explore-linguistic-quest',
    heroExploreTsoro: 'hero-explore-play-tsoro',

    // About
    aboutSection: 'about-section',
    aboutHeading: 'about-heading',

    // Platforms
    platformsSection: 'platforms-section',
    cardLinguisticQuest: 'platform-card-linguistic-quest',
    cardPlayTsoro: 'platform-card-play-tsoro',
    visitLqBtn: 'visit-linguistic-quest-button',
    visitTsoroBtn: 'visit-play-tsoro-button',

    // Coming soon
    comingSoonSection: 'coming-soon-section',
    comingSoonHeading: 'coming-soon-heading',

    // Footer
    footer: 'site-footer',
    footerContactEmail: 'footer-contact-email',
    footerLinkLq: 'footer-link-linguistic-quest',
    footerLinkTsoro: 'footer-link-play-tsoro',
};

export const PLATFORM_LINKS = {
    linguisticQuest: 'https://www.linguisticquest.com',
    playTsoro: 'https://www.playtsoro.com',
};

export const ASSETS = {
    logoBrand: '/brand/og-default.png',
    logoCircle: '/brand/logo-circle.png',
    imgPlayTsoro: '/brand/platform-play-tsoro.png',
    imgLinguisticQuest: '/brand/platform-linguistic-quest.png',
};
